import { makeVar } from '@apollo/client';
import {
  accessEventFiltersState,
  authInitialState,
  cardsInitialState,
  currentTenantInitialState,
  doorsInitialState,
  doorsWithLocationsInitialState,
  externalUsersGroupsInitialState,
  graphqlTokenInitialState,
  installersGroupsInitialState,
  locationsWithDoorsInitialState,
  mfaPreferenceInitialState,
  permissionsInitialState,
  requestStateInitialState,
  restApiKeysInitialState,
  schedulesInitialState,
  tenantLegalDocumentsInitialState,
  tenantRegistrationInfoInitialState,
  tenantsServiceTokenInitialState,
  uiInitialState,
  visitorGroupsWithIsOfficeModeEnabledInitialState,
  visitorsGroupsInitialState,
  visitorsGroupsMembersInitialState,
  visitorsGroupsWithAccessGrantsState
} from './initialStates';

export const doorsVar = makeVar(doorsInitialState);
export const doorsWithLocationsVar = makeVar(doorsWithLocationsInitialState);
export const graphqlTokenVar = makeVar(graphqlTokenInitialState);
export const authVar = makeVar(authInitialState);
export const locationsWithDoorsVar = makeVar(locationsWithDoorsInitialState);
export const locationsAndDoorsRefetchVar = makeVar(false);
export const uiVar = makeVar(uiInitialState);
export const accessEventFiltersVar = makeVar(accessEventFiltersState);
export const visitorsGroupsVar = makeVar(visitorsGroupsInitialState);
export const visitorsGroupsMembersVar = makeVar(visitorsGroupsMembersInitialState);
export const visitorsGroupsWithAccessGrantsVar = makeVar(visitorsGroupsWithAccessGrantsState);
export const externalUsersGroupsVar = makeVar(externalUsersGroupsInitialState);
export const installersGroupsVar = makeVar(installersGroupsInitialState);
export const schedulesVar = makeVar(schedulesInitialState);
export const requestStateVar = makeVar(requestStateInitialState);
export const permissionsVar = makeVar(permissionsInitialState);
export const mfaPreferenceVar = makeVar(mfaPreferenceInitialState);
export const cardsVar = makeVar(cardsInitialState);
export const visitorGroupsWithIsOfficeModeEnabledVar = makeVar(visitorGroupsWithIsOfficeModeEnabledInitialState);
export const tenantsServiceTokenVar = makeVar(tenantsServiceTokenInitialState);
export const tenantLegalDocumentsVar = makeVar(tenantLegalDocumentsInitialState);
export const tenantRegistrationInfoVar = makeVar(tenantRegistrationInfoInitialState);
export const restApiKeysVar = makeVar(restApiKeysInitialState);
export const currentTenantVar = makeVar(currentTenantInitialState);
export const backgroundRefetchesVar = makeVar<Set<symbol>>(new Set());
